import { useState } from "react";
import { Props } from "../../types";
import Container from "../Container";
import Radio from "./Radio";

type RadioSelectProps = Props<{
    items: Array<{ value: any; label: string }>;
    onChange?: (value: any) => void;
    defaultValue?: any;
}>;

const RadioSelect = (props: RadioSelectProps) => {
    const { items, onChange, defaultValue } = props;

    const [selected, setSelected] = useState<string | number>(
        defaultValue ?? 0
    );

    const _onChange = (value: any) => {
        setSelected(value);
        onChange && onChange(value)
    };

    return (
        <Container.Flex {...props} verticalGap={24} styles={{width: "max-content", margin: "0 auto 12px"}}>
            {items.map((el, idx) => (
                <Radio
                    selected={selected === el.value}
                    onChange={() => _onChange(el.value)}
                    label={el.label}
                    key={idx}
                />
            ))}
        </Container.Flex>
    );
};

export default RadioSelect;
